// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"e5dd692e","377":"d01f3945","928":"ec7d060b","973":"02f31b10"}[chunkId] + ".chunk.js";
};